import React, { Component } from 'react';

import get from 'lodash/get';
import find from 'lodash/find';
import axios from 'axios';

import { withRouter } from 'react-router-dom';
import axiosClient from 'utils/axios';
import FieldProcessor from './FieldProcessor';
import Auth from 'shared/Auth';
import localStorage from 'utils/localStorage';
import Text from 'ui/Text';
import { FormattedMessage } from 'react-intl';
import { PDFDownloadLink } from '@react-pdf/renderer';
import ResponsesDownload from './ResponsesDownload/index';
import Button from 'ui/Button';

class Responses extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sections: localStorage.getList(get(this.props.match.params, 'id')),
      activeSection: localStorage.getList(get(this.props.match.params, 'id')),
      loading: false,
      sectionHeading: get(localStorage.getList(get(this.props.match.params, 'id')), 'title'),
      responses: [],
    };

    this.axiosHandler = axios.CancelToken.source();
    this.reloadPageListener = null;
  }

  componentDidMount() {
    this.fetchAnswers();
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      sections: localStorage.getList(get(newProps.match.params, 'id')),
      activeSection: localStorage.getList(get(newProps.match.params, 'id')),
      sectionHeading: get(localStorage.getList(get(newProps.match.params, 'id')), 'title'),
    });
  }

  componentWillUnmount() {
    this.axiosHandler.cancel('Unmounting component');
  }

  loadSection = sectionId => {
    let section = find(this.state.sections, ['id', sectionId]);

    this.setState({
      activeSection: get(section, 'questions'),
      sectionHeading: get(section, 'title'),
    });
  };

  fetchAnswers = () => {
    this.setState({ loading: true });

    axiosClient
      .get(`/response?user_id=${get(Auth.getUser(), 'id')}`, {
        cancelToken: this.axiosHandler.token,
      })
      .then(response => {
        const rawResponses = get(response.data, 'returned_resultset');

        const processedResponses = {};

        rawResponses.forEach(rawResponse => {
          let finalResponse;

          try {
            finalResponse = JSON.parse(get(rawResponse, 'response'));
          } catch (e) {
            finalResponse = get(rawResponse, 'response');
          }

          processedResponses[get(rawResponse, 'question_id')] = finalResponse;
        });

        this.setState({
          responses: processedResponses,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
        });
      });
  };

  processQuestion = (questionDef, index, parentLink = false) => {
    const questions = get(questionDef, 'questions');

    const titleMap = {
      en_US: 'title',
      fr_FR: 'title_fr',
    };

    const currentLanguage = get(Auth.getLanguage(), 'lang');

    const titleKey = get(titleMap, currentLanguage);
    const baseQuestion =
      get(questionDef, 'question_type') === 'multiple_questions' ? (
        <div key={`${index}-${get(questionDef, titleKey)}`}>
          {parentLink ? (
            <p className="question-title primary-blue"> {get(questionDef, titleKey)}</p>
          ) : (
            <li className={`question-list__item__question ${get(questionDef, 'question_type')}`}>
              <p>
                {' '}
                {get(questionDef, titleKey)}
                <span className="primary-orange">
                  {get(questionDef, 'is_mandatory') ? '*' : null}
                </span>
              </p>
            </li>
          )}
          <ol className={`question-list ${get(questionDef, 'question_type')}`}>
            {questions.map((questionItem, qnIndex) => this.processQuestion(questionItem, qnIndex))}
          </ol>
        </div>
      ) : (
        <li className="question-list__item" key={`${index}-${get(questionDef, titleKey)}`}>
          <div className="question-list__item__question">
            <p>
              {get(questionDef, titleKey)}
              <span className="primary-orange">
                {get(questionDef, 'is_mandatory') ? '*' : null}
              </span>
            </p>
          </div>
          {questions && questions.length ? (
            questions.map((questionItem, qnIndex) => this.processQuestion(questionItem, qnIndex))
          ) : (
            <FieldProcessor
              titleKey={titleKey}
              valueKey="value"
              responses={this.state.responses}
              question={questionDef}
            />
          )}
        </li>
      );

    return baseQuestion;
  };

  render() {
    if (this.state.loading) {
      return <p className="pre-loader sub-head text-center">Loading Responses...</p>;
    }
    const titleMap = {
      en_US: 'title',
      fr_FR: 'title_fr',
    };

    const currentLanguage = get(Auth.getLanguage(), 'lang');

    const titleKey = get(titleMap, currentLanguage);

    let questionFields =
      this.state.activeSection &&
      this.state.activeSection.map((questionDef, index) =>
        this.processQuestion(questionDef, index, true)
      );

    let sections = this.state.sections.map((section, index) => (
      <li
        key={index}
        className="navigation-item"
        onClick={() => this.loadSection(get(section, 'id'))}>
        <span
          className={`navigation-item__link ${
            this.state.sectionHeading === get(section, 'title') ? 'active' : null
          }`}>
          {get(section, titleKey)}
        </span>
      </li>
    ));
    // console.log(this.state.responses);
    return (
      <section className="container-fluid responses-container">
        <div
          className="question-title"
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
          <Text modifiers="primary-blue">
            <FormattedMessage
              id="Questionnaire.CDR.SubMenuItem.4"
              defaultMessage="Question Responses"
            />
          </Text>
          {this.state.responses && (
            <PDFDownloadLink
              document={
                <ResponsesDownload
                  sections={this.state.sections}
                  responses={this.state.responses}
                />
              }
              fileName="responses.pdf">
              {({ blob, url, loading, error }) =>
                loading ? (
                  'Loading document...'
                ) : (
                  <Button nature="small">
                    <FormattedMessage
                      id="Questionnaire.DownloadResponses"
                      defaultMessage="Download Responses"
                    />
                  </Button>
                )
              }
            </PDFDownloadLink>
          )}
        </div>

        <div className="row">
          <div className="col-3 response-sidebar">
            <ul>{sections}</ul>
          </div>
          <div className="col-9 questions-container">
            <ol className="question-list">{questionFields}</ol>
          </div>
        </div>
      </section>
    );
  }
}

const WrappedResponse = withRouter(Responses);

export default WrappedResponse;



// WEBPACK FOOTER //
// ./src/components/CDRSections/Responses/index.js